<div class="center" style="background-image: url('../../../assets/Flag1.jpg'); background-size:100% 100%; background-position: bottom;">
    <div>
        <img src="assets/HomeLogo.png" width="125px" height="125px">
    </div>
    <div>
        <h5 class="center" style="color: #1f2d8a; font-weight: bold;">MILITARY ENGINEER SERVICES</h5>
        <h5 style="color: #1f2d8a; font-weight: bold;">CHIEF ENGINEER (NAVAL WORKS) - KOCHI ZONE</h5>
    </div>
</div>

<div id="wrapper">
    <div class="main-content">
        <div class="header center">
            <h4 style="color: #1f2d8a;">Sign Up</h4>
        </div>
        <div class="l-part">

            <div *ngIf="!showRegistrationPage">
                <div>
                    <p>To register, verify your mobile number and email address below.</p>
                    <p>
                        An OTP will be sent to your mobile number and registered email address for verification. 
                        Once verified, please fill in all the required details in the next screen. 
                        Upon successful submission, an authorized form will be sent to your registered email address.
                        Kindly, get it signed by the competent authority and contact the MES Office to enable your login.
                    </p>
                </div>
                
                <!-- Station Selection -->
                <div style="text-align: center; margin-top: 15px;">
                    <mat-form-field appearance="outline">
                        <mat-label>Station</mat-label>
                        <mat-select [(ngModel)]="selectedStation">
                            <mat-option *ngFor="let station of stations" [value]="station.value">
                                {{ station.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Mobile Number Input -->
                <div style="text-align: center; margin-top: 15px;">
                    <mat-form-field appearance="outline">
                        <mat-label>Mobile Number</mat-label>
                        <input matInput placeholder="Mobile Number" minlength="10" maxlength="10" 
                            [(ngModel)]="mobileNumber" spellcheck="false" (copy)="false" 
                            (cut)="false" (paste)="false">
                        <button mat-icon-button matSuffix>
                            <mat-icon>smartphone</mat-icon>
                        </button>
                    </mat-form-field>
                </div>

                <!-- Email Input -->
                <div style="text-align: center; margin-top: 8px;">
                    <mat-form-field appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput type="email" placeholder="Email Address" 
                            [(ngModel)]="email" spellcheck="false" (copy)="false" 
                            (cut)="false" (paste)="false">
                        <button mat-icon-button matSuffix>
                            <mat-icon>email</mat-icon>
                        </button>
                    </mat-form-field>
                </div>

                <!-- OTP Input -->
                <div *ngIf="showOtpField" style="text-align: center;">
                    <mat-form-field appearance="outline">
                        <mat-label>OTP</mat-label>
                        <input matInput placeholder="OTP" minlength="6" maxlength="6" 
                            [(ngModel)]="otp" spellcheck="false" (copy)="false" 
                            (cut)="false" (paste)="false">
                        <button mat-icon-button matSuffix>
                            <mat-icon>pin</mat-icon>
                        </button>
                    </mat-form-field>
                    <p *ngIf="showOtpField">Max 3 OTP validation attempts are allowed</p>
                    <div style="text-align: center; margin-bottom: 10px;">
                        <button mat-button (click)="resendOtp()" [disabled]="disableResendButton">
                            Resend OTP <span *ngIf="otpCooldownTime > 0">({{ otpCooldownTime }}s)</span>
                        </button>
                    </div>
                </div>

                <!-- Turnstile Captcha -->
                <div class="center">
                    <ngx-turnstile [siteKey]="'0x4AAAAAAAkPiEx2XU2Pm46_'" 
                        (resolved)="sendCaptchaResponse($event)" theme="light">
                    </ngx-turnstile>
                </div>

                <!-- Buttons and Countdown -->
                <div>
                    <span class="center" style="margin-top: 10px;">
                        <button mat-stroked-button (click)="backToLogin()" style="margin-left: 10px;">Back to home</button>
                        <button *ngIf="!submitOtpButton" mat-flat-button (click)="sendOtp()" style="margin-left: 10px;" [disabled]="mobileNumber.length !== 10 || !selectedStation || disableProceedButton || !validateEmail()">Proceed</button>
                        <button *ngIf="submitOtpButton" mat-flat-button (click)="validateOtp()" style="margin-left: 10px;" [disabled]="disableProceedButton">Proceed</button>
                    </span>
                </div>
            </div>

            <!-- Registration Page -->
            <div *ngIf="showRegistrationPage">
                <app-registration [selectedStation]="selectedStation" [userMobileNumber]="mobileNumber" [userEmail]="email" [token]="token"></app-registration>
            </div>
        </div>
    </div>
</div>
